/**
 * Wörterbuch: Fachbegriffe, die je nach Branche oder Firma anders heissen («Baustelle» bei Gärtnern, «Objekt» bei
 * Elektrikern). Kern-Standard hier; Branchenpakete überschreiben (api/src/pakete/<paket>/begriffe.js), die Firma
 * zuletzt (Verwaltung → Begriffe).
 *
 * Wird von API und App gemeinsam genutzt (die App importiert diese Datei direkt) – darum ohne Abhängigkeiten.
 * Nur kurze, sichtbare Begriffe; keine ganzen Sätze, keine Rechtstexte (die sind Einstellungen).
 */
export const BEGRIFFE = Object.freeze({
  produkt: 'WorkStudio',

  auftrag: 'Auftrag',
  auftraege: 'Aufträge',
  baustelle: 'Baustelle',
  baustellenuebersicht: 'Baustellenübersicht',
  kunde: 'Kunde',
  team: 'Team',

  'tab.uebersicht': 'Übersicht',
  'tab.erfassen': 'Erfassen',
  'tab.zeitMaterial': 'Zeit & Material',
  'tab.zeitplan': 'Zeitplan',
  'tab.kunde': 'Kunde',
  'tab.kundeninfos': 'Kundeninfos',
  'tab.notizen': 'Notizen',
  'tab.fotosNotizen': 'Fotos & Notizen',
  'tab.dateien': 'Dateien',
  'tab.dateienBilder': 'Dateien & Bilder',
  'tab.mehr': 'Mehr',

  'kachel.kunde.text': 'Kontakt, Zugang, Anlage',
  'kachel.dateien.text': 'Pläne, Fotos, Dokumente',
  'kachel.zeitplan.text': 'Phasen und Termine',
});

/** Beschreibung pro Schlüssel für die Verwaltung (wo der Begriff erscheint). */
export const BEGRIFFE_HILFE = Object.freeze({
  produkt: 'Name der App: Seitenleiste, Anmeldung, Fusszeile von Excel und PDF',
  auftrag: 'Einzahl, z. B. «Auftrag wechseln», «Mehr zum Auftrag»',
  auftraege: 'Mehrzahl, z. B. «alle Aufträge»',
  baustelle: 'Ort der Arbeit, z. B. Überschrift auf der Übersicht',
  baustellenuebersicht: 'Titel der Übersicht eines Auftrags',
  kunde: 'Auftraggeber',
  team: 'Überschrift «Team auf dem Auftrag»',
  'tab.uebersicht': 'Untere Leiste (Handy)',
  'tab.erfassen': 'Untere Leiste (Handy)',
  'tab.zeitMaterial': 'Seitenleiste und Seitentitel',
  'tab.zeitplan': 'Seitenleiste und Seitentitel',
  'tab.kunde': 'Kurzform',
  'tab.kundeninfos': 'Seitenleiste, Seitentitel und Kachel unter «Mehr»',
  'tab.notizen': 'Untere Leiste (Handy)',
  'tab.fotosNotizen': 'Seitenleiste und Seitentitel',
  'tab.dateien': 'Kurzform',
  'tab.dateienBilder': 'Seitenleiste, Seitentitel und Kachel unter «Mehr»',
  'tab.mehr': 'Untere Leiste (Handy)',
  'kachel.kunde.text': 'Untertitel der Kachel Kundeninfos unter «Mehr»',
  'kachel.dateien.text': 'Untertitel der Kachel Dateien unter «Mehr»',
  'kachel.zeitplan.text': 'Untertitel der Kachel Zeitplan unter «Mehr»',
});
